/* eslint-disable no-console */
/* eslint-disable react/jsx-first-prop-new-line */
/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import Modal from '../../containers/modal.jsx';
import styles from './QRCodeModal.css';


import Box from '../box/box.jsx';
import classnames from 'classnames';

import { setSession } from '../../reducers/session.js';
import { closeQrCode } from '../../reducers/modals.js';
import { connect } from 'react-redux';
import { QRCodeSVG } from 'qrcode.react';

// {
//     "hours": 12,
//     "status": "ok",
//     "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJRCI6Inpob3V3ZWkiLCJleHAiOjE2OTcwNjM2NjV9.13eGDrXC1bA0uBH4bCyf8ihRd1Tv1_0JMw7DmAnj-rs",
//     "user": {
//         "UserId": "zhouwei",
//         "Nick": "周老师",
//         "Email": "769479627@qq.com",
//         "Submit": 486,
//         "Solved": 146,
//         "Defunct": "N",
//         "Accesstime": "2023-10-05T13:29:00+08:00",
//         "Volume": 10,
//         "Avatar": "https://oj-1256154465.cos.ap-shanghai.myqcloud.com/wangpan/15vDgGWR_cfeb97daf245c01e824b6b909a22156.jpg",
//         "Language": 1,
//         "Password": "",
//         "Description": "",
//         "School": "pachong",
//         "UserRight": "AT",
//         "Ip": "",
//         "RegTime": "0001-01-01T00:00:00Z"
//     }
// }

function QRCodeModal(props) {

    return (<>
        {props.showQRCode && <Modal
            className={styles.modalContent}
            // contentLabel={"登录"}
            id="QRCodeModal"
            onRequestClose={() => {
                props.closeQrCode()
            }}
        >
            <div className={styles.loginBG} >
                <Box
                    className={styles.boxPadding}
                >
                    <QRCodeSVG
                        value={props.QRCodeUrl}
                        size={300}
                        bgColor={"#ffffff"}
                        fgColor={"#000000"}
                        level={"L"}
                        includeMargin={false}
                    />
                </Box>
            </div >

        </Modal >}

    </>)
}

const mapStateToProps = states => ({
    session: states.session,
    modals: states.modals,
    showQRCode: states.scratchGui.modals.qrCode,
    QRCodeUrl: states.scratchGui.modals.QRCodeUrl

})
const mapDispatchToProps = dispatch => ({
    setSession: (session) => dispatch(setSession(session)),
    closeQrCode: () => dispatch(closeQrCode())
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QRCodeModal);
// export default LoginModal;
